import React from "react";
import { FiFacebook, FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import {
  CardsGrid,
  ContactListContainer,
  ContactLogo,
  LogoPanel,
} from "./ContactListElements";
import { ContactCard } from "../ContactCard";
import { Reveal } from "../../general/Reveal";
import { useLanguage } from "../../../contexts/LanguageContext";
import {
  EMAIL,
  FACEBOOK_URL,
  PHONE_NUMBERS,
  toMapsHref,
  toTelHref,
} from "../../../utils";

const ContactList = () => {
  const { t } = useLanguage();

  const cards = [
    {
      icon: FiMapPin,
      label: t("CONTACT.ADDRESS_LABEL"),
      items: [t("FOOTER.ADDRESS1"), t("FOOTER.ADDRESS2")].map((address) => ({
        text: address,
        href: toMapsHref(address),
        external: true,
      })),
    },
    {
      icon: FiPhone,
      label: t("CONTACT.PHONE_LABEL"),
      items: PHONE_NUMBERS.map((phone) => ({
        text: phone,
        href: toTelHref(phone),
      })),
    },
    {
      icon: FiMail,
      label: t("CONTACT.EMAIL_LABEL"),
      items: [{ text: EMAIL, href: `mailto:${EMAIL}` }],
    },
    {
      icon: FiFacebook,
      label: t("CONTACT.SOCIAL_LABEL"),
      items: [{ text: "Facebook", href: FACEBOOK_URL, external: true }],
    },
  ];

  return (
    <ContactListContainer>
      <CardsGrid>
        {cards.map((card, index) => (
          <Reveal key={card.label} delay={index * 0.08}>
            <ContactCard {...card} />
          </Reveal>
        ))}
      </CardsGrid>
      <Reveal from="right" delay={0.2} duration={1}>
        <LogoPanel>
          <ContactLogo
            alt={t("HOME.HEADER.TITLE")}
            src={require("../../../assets/images/logos/Full-logo.png")}
          />
        </LogoPanel>
      </Reveal>
    </ContactListContainer>
  );
};

export default ContactList;
